import axios from "axios";

const endpointAPI = "https://app.cultivandofuturo.com/api/v1";
const APIKEY = process.env.VUE_APP_APIKEY

// import fb from "@/firebase";

export default {
  getMetricasLanding() {
    return new Promise((resolve, reject) => {
      axios.get(`${endpointAPI}/landing/metricas`).then(res => {
        resolve(res.data);
      });
    });
  },
  getProductos() {
    return new Promise((resolve, reject) => {
      axios.get(`${endpointAPI}/public/productos`).then(res => {
        resolve(res.data);
      });
    });
  },
  getPaises() {
    return new Promise((resolve, reject) => {
      axios.get(`${endpointAPI}/ubicacion/paises`).then(res => {
        resolve(res.data);
      });
    });
  },
  getDepartamentos(idPais) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${endpointAPI}/ubicacion/departamentos?id_pais=${idPais}`)
        .then(res => {
          resolve(res.data);
        });
    });
  },
  getMunicipios(idDepartamento) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${endpointAPI}/ubicacion/ciudades?id_departamento=${idDepartamento}`
        )
        .then(res => {
          resolve(res.data);
        });
    });
  },
  getItems() {
    return new Promise((resolve, reject) => {
      axios.get(`${endpointAPI}/items-grupos-agroproductor`).then(res => {
        resolve(res.data);
      });
    });
  },
  registrarProductor(nuevoRegistro) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${endpointAPI}/public/registro-productor`, {
          registro: nuevoRegistro
        })
        .then(res => {
          resolve(res.data);
        });
    });
  },
  registrarComprador(registroComprador) {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await axios.post(`${endpointAPI}/public/registro-comprador`, {
          registroComprador
        })
        resolve(res.data);
      } catch (err) {
        reject(err);
      }
    });
  },
  confirmAccount(username, codigo) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${endpointAPI}/usuarios/confirm-account`, {
          data: {
            username,
            codigo
          }
        })
        .then(res => {
          resolve(res.data);
        });
    });
  },
  getProducciones() {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await axios.get(`${endpointAPI}/public/calendario-produccion/producciones`);

        if (res.data.status) {
          resolve(res.data.producciones)
        } else {
          reject(res.data)
        }

      } catch (err) {
        console.error(err);
        reject(err)
      }
    });
  },
  solicitarProducto(solicitarProducto, selectedProduccion) {
    return new Promise(async (resolve, reject) => {
      try {

        let res = await axios.post(`${endpointAPI}/landing/solicitar-producto?produccion=${selectedProduccion}`, {
          data: solicitarProducto
        });

        if (res.data.status) {
          resolve(true);
        } else {
          reject(false)
        }

      } catch (err) {
        reject(err);
      }
    })
  },
  getCompradores() {
    return new Promise(async (resolve, reject) => {
      try {

        let res = await axios.get(`${endpointAPI}/public/calendario-produccion/compradores`,{
          headers:{
            'x-api-key':APIKEY
          }
        });
        resolve(res.data);

      } catch (err) {
        reject(err);
      }
    })
  }
};
